import React, { useEffect, useMemo, useState } from 'react'
import { reservationService } from '../../../services/reservation.service'
import { QrDetailCard } from '../../../components/Dashboard/QrDetailCard'
import { PastTicketCard } from '../../../components/PastTicketCard'
import { UpcomingTicketCard } from '../../../components/UpcomingTicketCard'

export const AccountEvents = () => {
  const [reservations, setReservations] = useState([])
  useEffect(() => {
    const getAllReservations = async () => {
      try {
        const reservaciones = await reservationService.getAllReservationsById()
        setReservations(reservaciones)
        console.log(reservaciones)
      } catch (error) {
        console.log(error)
      }
    }

    getAllReservations()
  }, [])
  // return (
  //   <>
  //     {/* Account collections */}
  //     <div className="pb-5 mb-lg-2 mt-md-0">
  //       <div className="ps-md-3 ps-lg-0 mt-md-2 pt-md-4 pb-md-2">
  //         <div className="d-sm-flex align-items-center justify-content-between pt-xl-1 mb-3 pb-3">
  //           <h1 className="h2 mb-sm-0 text-primary">Mis reservaciones</h1>
  //           <select className="form-select" style={{ maxWidth: '15rem' }}>
  //             <option value="Published">Ordenar</option>
  //             <option value="Category">Más reciente</option>
  //             <option value="Title AZ">Más viejo</option>
  //           </select>
  //         </div>
  //         {
  //           reservations.map((reservation, index) => (
  //             <QrDetailCard
  //               key={index}
  //               {...reservation} />)
  //           )
  //         }
  //       </div>
  //     </div>

  //   </>
  // )
  return (
    <>
      <div>
          <div className="row">
            {/* Content */}
              <div className="card_descripcion">
                <h2 className="h1 pb-md-2 pb-lg-3 text-primary">Tus boletos</h2>
                <h4 className='primary'>Próximos eventos</h4>
                {
                  reservations.map((Tickets, index) => (
                    <div className="col" key={index}>
                      <UpcomingTicketCard
                      {...Tickets}
                    />
                    </div>
                  ))
                }
              </div>
              <div className="past_events">
              <h4>Eventos pasados</h4>
              {
                reservations.map((Tickets, index) => (
                  <div className="col" key={index}>
                    <PastTicketCard
                      {...Tickets}
                    />
                  </div>
                ))
              }
              </div>
          </div>
      </div>
    </>
  )
}
